<template>
  <div>
    <b-modal
      v-model="modalShow"
      size="xl"
      class="min-h"
      centered
      no-close-on-backdrop
      no-close-on-esc
      modal-class="custom-modal"
    >
      <template #modal-header>{{ checkType() }}</template>
      <b-row :class="{ 'justify-content-end': type !== 1 }" class="mt-1">
        <b-col cols="3" v-if="type == 1">
          <MultiSelect
            textFloat=""
            :options="productBrandList"
            textField="name"
            valueField="id"
            placeholder="Select Product Brand"
            v-model="filter.product_brand_id"
            :value="filter.product_brand_id"
            @input="getProduct"
          />
        </b-col>
        <b-col cols="3" v-if="type == 1">
          <MultiSelect
            textFloat=""
            :options="modelList"
            textField="name"
            valueField="id"
            placeholder="Select Model"
            v-model="filter.select_model"
            :value="filter.select_model"
            @input="getProduct"
          />
        </b-col>
        <b-col cols="3" v-if="type == 1">
          <MultiSelect
            textFloat=""
            :options="modelStatusList"
            textField="name"
            valueField="id"
            placeholder="Select Model Status"
            v-model="filter.select_model_status"
            :value="filter.select_model_status"
            @input="getProduct"
          />
        </b-col>
        <b-col cols="3" v-if="type == 1">
          <MultiSelect
            class=""
            textFloat=""
            :options="subModelList"
            textField="name"
            valueField="id"
            placeholder="Select Sub Model"
            v-model="filter.select_sub_model"
            :value="filter.select_sub_model"
            @input="getProduct"
          />
        </b-col>
        <b-col cols="3" v-if="type == 1">
          <MultiSelect
            class="mt-3"
            textFloat=""
            :options="branchList"
            textField="name"
            valueField="id"
            placeholder="Select Branch"
            v-model="filter.branch_id"
            :value="filter.branch_id"
            @input="getProduct"
          />
        </b-col>
        <b-col cols="6" v-if="type == 1"></b-col>
        <b-col :cols="type == 4 ? 3 : 6">
          <b-form-checkbox
            v-model="select_all"
            :value="1"
            :unchecked-value="0"
            @change="selectAll()"
            :class="[{ 'mt-4': type === 1, 'mt-2': type > 1 }]"
          >
            Select All
          </b-form-checkbox>
        </b-col>
        <b-col cols="6" v-if="type == 3"></b-col>

        <b-col cols="6">
          <b-input-group :class="{ 'mt-3 ': type == 1 }">
            <b-form-input
              :placeholder="
                type == 1
                  ? ' Search Product Name, Serial'
                  : 'Search Document Name'
              "
              v-model.trim="filter.search"
              @keyup.enter="handleSearch"
            ></b-form-input>
            <b-input-group-append>
              <b-input-group-text>
                <b-iconstack
                  font-scale="2"
                  type="submit"
                  @click.prevent="handleSearch"
                >
                  <b-icon
                    stacked
                    icon="search"
                    scale="0.5"
                    variant="grey"
                  ></b-icon>
                </b-iconstack>
              </b-input-group-text>
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col cols="3" v-if="type == 4">
          <InputSelect
            title=""
            :options="TransferFormList"
            textField="name"
            valueField="id"
            @onDataChange="getProduct"
            v-model="filter.inventory_transfer_document_id"
          >
            <template v-slot:option-first>
              <b-form-select-option :value="null" disabled
                >-- Select Transfer Form --</b-form-select-option
              >
              <b-form-select-option value="">All</b-form-select-option>
            </template>
          </InputSelect>
        </b-col>
      </b-row>

      <b-table
        responsive
        striped
        hover
        :fields="fields"
        :items="items"
        :busy="isBusy"
        show-empty
        class="mt-3"
        empty-text="No matching records found"
      >
        <template v-slot:table-busy>
          <div class="text-center text-black my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong class="ml-2">Loading...</strong>
          </div>
        </template>
        <template #head(action)="data"
          ><b-form-checkbox
            v-model="selectAllPage"
            @change="toggleAll()"
          ></b-form-checkbox>
        </template>

        <template #cell(weight)="{ item }">
          {{ item.weight | numeral("0,0.00") }}
        </template>
        <template #cell(document_type)="{ item }">
          {{ item.document_type || "-" }}
        </template>
        <template #cell(created_time)="{ item }">
          <div>{{ item.created_time | moment($formatDateNew) }}</div>
          <span class="text-gray">{{
            item.created_time | moment("HH:mm:ss")
          }}</span>
        </template>
        <template #cell(price)="{ item }">
          {{ item.price | numeral("0,0.00") }} บาท
        </template>
        <template #cell(sale_status)="{ item }">
          {{ item.sale_status || "-" }}
        </template>

        <template #cell(fg_code)="{ item }">
          {{ item.fg_code || "-" }}
        </template>
        <template #cell(size)="{ item }">
          {{ item.size || "-" }}
        </template>

        <template #cell(serial)="{ item }">
          {{ item.serial || "-" }}
        </template>
        <template #cell(product_name)="{ item }">
          {{ item.product_name || "-" }}
        </template>
        <template #cell(manufacturer_name)="{ item }">
          {{ item.manufacturer_name || "-" }}
        </template>

        <template v-slot:cell(action)="{ item }">
          <b-form-group class="cb-table d-flex justify-content-center m-0">
            <b-form-checkbox
              :value="item"
              :checked="selectedProduct"
              @change="selectProductTable(item)"
            ></b-form-checkbox> </b-form-group
        ></template>
      </b-table>

      <Pagination
        @handleChangeTake="handleChangeTake"
        hideTake="true"
        :filter="filter"
        :rows="rows"
        @pagination="pagination"
      />
      <template #modal-footer>
        <div class="w-100 d-flex justify-content-between">
          <b-button @click.prevent="hide" class="border-btn">Cancel</b-button>

          <b-button
            class="submit-btn text-right"
            @click.prevent="submitSelectProduct"
            >Select Items</b-button
          >
        </div>
      </template>
    </b-modal>
    <ModalProcess ref="modalProcess" />
  </div>
</template>
<script>
import InputSelect from "@/components/inputs/InputSelect";
import ModalProcess from "./ModalProcess.vue";

export default {
  components: {
    InputSelect,
    ModalProcess,
  },
  props: {
    selectedItem: {
      type: Array,
      Default: [],
    },
    date: {
      type: String,
      Default: "",
    },
    is_franchise: {
      type: Number,
      Default: 0,
    },
    TransferFormList: { type: Array, Default: [] },
  },
  data() {
    return {
      modalShow: false,
      isBusy: false,
      fields: [
        { key: "action", label: "" },
        { key: "index", label: "ลำดับ" },
        { key: "fg_code", label: "FG CODE" },
        { key: "barcode", label: "รหัสสินค้า" },

        { key: "serial", label: "Serial No." },
        { key: "sale_status", label: "Model Status" },
        { key: "size", label: "Sizes" },
        { key: "weight", label: "WGT" },
        { key: "price", label: "ราคา" },
      ],
      showing: 1,
      showingTo: 5,
      filter: {
        user_guid: this.$cookies.get("print_tag_admin_user_guid"),
        page: 1,
        take: 5,
        search: "",
        select_model: [],
        select_sub_model: [],
        select_model_status: [],
        add_product_id: [],
        delete_product_id: [],
        branch_id: [],
        inventory_transfer_document_id: null,
        product_brand_id: [],
      },

      rows: 0,

      items: [],
      selectedProduct: [],
      isLoading: false,
      mapProduct: [],
      modelList: [],
      modelStatusList: [],
      subModelList: [],
      type: 0,
      user_guid: "",
      branchList: [],
      selectAllPage: false,
      select_all: 0,
      productBrandList: [],
    };
  },
  methods: {
    async show(type) {
      this.modalShow = true;
      this.type = type;
      await this.getProduct(this.type);
      this.user_guid = this.$cookies.get("print_tag_admin_user_guid");
      this.selectedProduct = this.selectedItem ? [...this.selectedItem] : [];
      this.selectAllPage = false;
      this.select_all = 0;
      if (this.type == 1) {
        this.fields = [
          { key: "action", label: "" },
          { key: "index", label: "ลำดับ" },
          { key: "fg_code", label: "FG CODE" },
          { key: "barcode", label: "รหัสสินค้า" },

          { key: "serial", label: "Serial No." },
          { key: "sale_status", label: "Model Status" },
          { key: "size", label: "Sizes" },
          { key: "weight", label: "WGT" },
          { key: "price", label: "ราคา" },
        ];
      } else if (this.type == 2) {
        this.fields = [
          { key: "action", label: "" },
          { key: "index", label: "ลำดับ" },
          { key: "document_no", label: "เลขเอกสาร STK" },
          { key: "manufacturer_name", label: "เลขเอกสาร PO" },
          { key: "created_time", label: "วันที่สร้าง" },
        ];
      } else if (this.type == 4) {
        this.fields = [
          { key: "action", label: "" },
          { key: "index", label: "ลำดับ" },
          { key: "document_no", label: "เลขเอกสาร" },
          { key: "document_type", label: "ชนิดเอกสาร" },
          { key: "created_time", label: "วันที่สร้าง" },
        ];
      } else if (this.type == 5) {
        this.fields = [
          { key: "action", label: "" },
          { key: "index", label: "ลำดับ" },
          { key: "document_no", label: "เลขเอกสาร" },
          { key: "product_name", label: "ชื่อสินค้า" },
          { key: "created_time", label: "วันที่สร้าง" },
        ];
      } else if (
        this.type == 6 ||
        this.type == 7 ||
        this.type == 8 ||
        this.type == 9 ||
        this.type == 10
      ) {
        this.fields = [
          { key: "action", label: "" },

          { key: "invoice_no", label: "เลขเอกสาร" },

          { key: "created_time", label: "วันที่สร้าง" },
        ];
      }
    },
    async getProduct() {
      this.isBusy = true;
      let res;
      if (this.type == 1) {
        await Promise.all([
          this.getProductModelList(),
          this.getProductModelStatusList(),
          this.getProductSubModelList(),
          this.getBranchList(),
          this.getProductBrandList(),
        ]);
        res = await this.axios.post(`/printtag/GetProductList`, this.filter);
      } else if (this.type == 4) {
        res = await this.axios.post(
          `/printtag/GetInventoryTransferList`,
          this.filter
        );
      } else if (this.type == 2) {
        res = await this.axios.post(`/printtag/GetSTKList`, this.filter);
      } else if (this.type == 5) {
        res = await this.axios.post(`/printtag/GetRepairList`, this.filter);
      } else if (this.type == 6) {
        res = await this.axios.post(`/printtag/GetCNList`, this.filter);
      } else if (this.type == 7) {
        res = await this.axios.post(
          `/printtag/GetInvoiceFranchiseList`,
          this.filter
        );
      } else if (this.type == 8) {
        res = await this.axios.post(`/printtag/GetRRTList`, this.filter);
      } else if (this.type == 9) {
        res = await this.axios.post(`/printtag/GetInvoiceList`, this.filter);
      } else if (this.type == 10) {
        res = await this.axios.post(
          `/printtag/GetInvoiceConsignmentList`,
          this.filter
        );
      }
      this.rows = res.data.detail.total_count;
      this.items = res.data.detail.detail.map((x, index) => ({
        ...x,
        index: index + 1 + this.filter.take * (this.filter.page - 1),
        id: x.user_transaction_id || x.id,
      }));

      this.selectAllPage =
        this.type !== 6
          ? this.items.every((item) =>
              this.selectedProduct.some((p) => p.id === item.id)
            )
          : this.items.every((item) =>
              this.selectedProduct.some(
                (p) => p.user_transaction_id === item.user_transaction_id
              )
            );
      if (this.select_all) {
        this.selectedProduct.push(...this.items);
        this.selectAllPage = true;
      }

      this.isBusy = false;
    },
    checkType() {
      if (this.type == 1) {
        return "สินค้า";
      }
      if (this.type == 2) {
        return "เอกสารรับเข้า STK";
      }
      if (this.type == 4) {
        return "เอกสาร Inventory Transfer";
      }
      if (this.type == 5) {
        return "เอกสาร Repair";
      }
      if (this.type == 6) {
        return "เอกสาร CN";
      }
      if (this.type == 7) {
        return "เอกสาร Franchise";
      }
      if (this.type == 8) {
        return "เอกสาร RRT";
      }
      if (this.type == 9) {
        return "เอกสาร Invoice";
      }
      if (this.type == 10) {
        return "เอกสาร Invoice Consignment";
      }
    },
    pagination(page) {
      this.filter.page = page;
      this.getProduct();
    },
    handleChangeTake() {
      this.getProduct();
    },
    handleSearch() {
      this.getProduct();
    },
    selectProductTable(product) {
      var index;
      if (this.type !== 6) {
        index = this.selectedProduct.findIndex(
          (item) => item.id === product.id && item.serial === product.serial
        );
      } else {
        index = this.selectedProduct.findIndex(
          (item) => item.user_transaction_id === product.user_transaction_id
        );
      }

      if (index !== -1) {
        this.selectedProduct.splice(index, 1);
      } else {
        this.selectedProduct.push(product);
      }
    },
    async getProductModelList() {
      const res = await this.axios(`/printtag/GetProductModelList `);
      this.modelList = res.data.detail || [];
    },
    async getProductModelStatusList() {
      const res = await this.axios(`/printtag/GetProductModelStatusList `);
      this.modelStatusList = res.data.detail || [];
    },
    async getProductSubModelList() {
      const res = await this.axios(`/printtag/GetProductSubModelList `);
      this.subModelList = res.data.detail || [];
    },
    async getBranchList() {
      const res = await this.axios(`/printtag/GetBranchList `);
      this.branchList = res.data.detail || [];
    },
    async getProductBrandList() {
      const res = await this.axios(`/printtag/GetProductBrandList  `);
      this.productBrandList = res.data.detail || [];
    },
    async submitSelectProduct() {
      console.log("trigger");
      this.modalShow = false;
      if (this.selectedProduct.length === 0 && this.select_all === 0) {
        return;
      }
      this.$bus.$emit("showLoading");
      let url = "";
      let payload = {
        user_guid: this.user_guid,
        select_all: this.select_all,
        filter: this.filter,
        date: this.date,
        is_franchise: this.is_franchise,
      };
      this.filter = {
        user_guid: this.$cookies.get("print_tag_admin_user_guid"),
        page: 1,
        take: 5,
        search: "",
        add_product_id: [],
        delete_product_id: [],
        select_model: [],
        select_sub_model: [],
        select_model_status: [],
        branch_id: [],
        inventory_transfer_document_id: null,
        product_brand_id: [],
      };
      if (this.type === 1) {
        url = "/printtag/create";
        payload.product_id_list = this.select_all
          ? []
          : this.selectedProduct.map(({ id, serial }) => ({
              id,
              serial,
            }));
      } else if (this.type === 2) {
        url = "/printtag/Create/po/stk/new";
        payload.po_id_list = this.select_all
          ? []
          : this.selectedProduct.map((item) => item.id);
      } else if (this.type === 4) {
        url = "/printtag/create/inventory/transfer";
        payload.inventory_transfer_id_list = this.select_all
          ? []
          : this.selectedProduct.map((item) => item.id);
      } else if (this.type === 5) {
        url = "/printtag/create/repair/transaction";
        payload.repair_id_list = this.select_all
          ? []
          : this.selectedProduct.map((item) => item.id);
      } else if (this.type === 6) {
        url = "/printtag/Create/CN";
        payload.product_id_list = this.select_all
          ? []
          : this.selectedProduct.flatMap((x) =>
              x.products.map((p) => ({
                id: p.product_id,
                serial: p.serial,
              }))
            );
      } else if (this.type === 7) {
        console.log("Invoice Franchise", this.selectedProduct);
        url = "/printtag/Create/InvoiceFranchise";
        payload.invoice_id_list = this.selectedProduct.map((item) => item.id);
      } else if (this.type === 8) {
        url = "/printtag/Create/RRT";
        payload.return_id_list = this.selectedProduct.map((item) => item.id);
      } else if (this.type === 9) {
        url = "/printtag/Create/Invoice";
        payload.product_id_list = this.select_all
          ? []
          : this.selectedProduct.flatMap((x) =>
              x.products.map((p) => ({
                id: p.product_id,
                serial: p.serial,
              }))
            );
      } else if (this.type === 10) {
        url = "/printtag/Create/InvoiceConsignment";
        payload.product_id_list = this.select_all
          ? []
          : this.selectedProduct.flatMap((x) =>
              x.products.map((p) => ({
                id: p.product_id,
                serial: p.serial,
              }))
            );
      }
      const res = await this.axios.post(url, payload);
      if (res.data.result) {
        if (res.data) {
          this.$bus.$emit("hideLoading");
          const load = await this.axios(`/printtag/GetProcessProduct`);
          if (load.data.detail.is_procress && this.$refs.modalProcess) {
            await this.$refs.modalProcess.show();
            try {
              await this.pollProcess();
              this.$refs.modalProcess.hide();

              this.$emit("success");
            } catch (e) {
              this.$refs.modalProcess.hide();
              this.errorAlert(e.message);
            }
          } else {
            this.$refs.modalProcess.hide();

            this.$emit("success");
          }
        }
      } else {
        this.errorAlert(res.data.message);
      }
      this.$bus.$emit("hideLoading");
    },
    async pollProcess() {
      let delay = 1000;
      const maxDelay = 5000;
      const timeout = 120000;
      const start = Date.now();

      while (true) {
        if (Date.now() - start > timeout) {
          throw new Error("Processing timeout");
        }

        const load = await this.axios(`/printtag/GetProcessProduct`);
        if (!load.data.detail.is_procress) {
          return;
        }

        await new Promise((r) => setTimeout(r, delay));
        delay = Math.min(delay * 1.5, maxDelay);
      }
    },
    hide() {
      this.filter = {
        user_guid: this.$cookies.get("print_tag_admin_user_guid"),
        page: 1,
        take: 5,
        search: "",
        add_product_id: [],
        delete_product_id: [],
        select_model: [],
        select_sub_model: [],
        select_model_status: [],
        branch_id: [],
        inventory_transfer_document_id: null,
        product_brand_id: [],
      };
      this.select_all = 0;
      this.selectAllPage = false;
      this.selectedProduct = [];
      this.modalShow = false;
    },
    toggleAll() {
      if (this.selectAllPage) {
        this.selectedProduct.push(...this.items);
      } else {
        this.selectedProduct = this.selectedProduct.filter(
          (p) =>
            !this.items.some(
              (item) =>
                item.id === p.id &&
                (this.type !== 6 ||
                  item.user_transaction_id === p.user_transaction_id)
            )
        );
      }
    },
    selectAll() {
      if (this.select_all) {
        this.selectedProduct.push(...this.items);
        this.selectAllPage = true;
      } else {
        this.selectedProduct = [];
        this.selectAllPage = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.pic-box {
  margin: auto !important;
  width: 50%;
  padding-top: 50%;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}

::v-deep .custom-modal {
  .modal-body {
    min-height: 456px !important;
  }
}
</style>
